/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessUpdateShadowMCPInventoryServerName } from "../funcs/accessUpdateShadowMCPInventoryServerName.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateShadowMCPInventoryServerNameRequest,
  UpdateShadowMCPInventoryServerNameSecurity,
} from "../models/operations/updateshadowmcpinventoryservername.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateShadowMCPInventoryServerNameMutationVariables = {
  request: UpdateShadowMCPInventoryServerNameRequest;
  security?: UpdateShadowMCPInventoryServerNameSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateShadowMCPInventoryServerNameMutationData = void;

export type UpdateShadowMCPInventoryServerNameMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateShadowMCPInventoryServerName access
 *
 * @remarks
 * Update or clear the administrator-defined display name for one project-scoped Shadow MCP inventory server URL.
 */
export function useUpdateShadowMCPInventoryServerNameMutation(
  options?: MutationHookOptions<
    UpdateShadowMCPInventoryServerNameMutationData,
    UpdateShadowMCPInventoryServerNameMutationError,
    UpdateShadowMCPInventoryServerNameMutationVariables
  >,
): UseMutationResult<
  UpdateShadowMCPInventoryServerNameMutationData,
  UpdateShadowMCPInventoryServerNameMutationError,
  UpdateShadowMCPInventoryServerNameMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateShadowMCPInventoryServerNameMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateShadowMCPInventoryServerName(): MutationKey {
  return ["@gram/client", "access", "updateShadowMCPInventoryServerName"];
}

export function buildUpdateShadowMCPInventoryServerNameMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateShadowMCPInventoryServerNameMutationVariables,
  ) => Promise<UpdateShadowMCPInventoryServerNameMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateShadowMCPInventoryServerName(),
    mutationFn: function updateShadowMCPInventoryServerNameMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateShadowMCPInventoryServerNameMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessUpdateShadowMCPInventoryServerName(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
